import { render, staticRenderFns } from "./DetailRecommendGoodItem.vue?vue&type=template&id=ebf963c8&scoped=true&"
import script from "./DetailRecommendGoodItem.vue?vue&type=script&lang=js&"
export * from "./DetailRecommendGoodItem.vue?vue&type=script&lang=js&"
import style0 from "./DetailRecommendGoodItem.vue?vue&type=style&index=0&id=ebf963c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf963c8",
  null
  
)

export default component.exports